import React from "react";
import type { MeasureValue } from "../../../types/stationPerformance";
import MeasureValueCell from "./MeasureValueCell";

interface FreeShareCellProps {
  energyShare: MeasureValue | null | undefined;
  sessionShare: MeasureValue | null | undefined;
}

/**
 * Free share of energy and of sessions, side by side.
 *
 * Deliberately shows both. They diverge whenever free sessions are systematically longer or shorter
 * than paid ones: 10 free sessions at 40 kWh against 40 paid at 5 kWh is 67% of energy but 20% of
 * sessions, and FR-002k forbids either standing in for the other.
 *
 * This is also the most load-bearing cell on the screen: no figure anywhere values free energy, so money
 * *understates* stations that shifted to free charging. Free share is the only thing that stops that
 * being read as decline.
 */
const FreeShareCell: React.FC<FreeShareCellProps> = ({ energyShare, sessionShare }) => (
  <div className="flex flex-column">
    <span title="Free share of energy">
      <MeasureValueCell measure={energyShare} format="percent" decimals={1} />
      <span className="text-color-secondary text-xs ml-1">kWh</span>
    </span>
    <span title="Free share of sessions">
      <MeasureValueCell measure={sessionShare} format="percent" decimals={1} />
      <span className="text-color-secondary text-xs ml-1">sessions</span>
    </span>
  </div>
);

export default FreeShareCell;
